import React from 'react';
import PropTypes from 'prop-types';
import { gettext } from '@eventbrite/i18n';

import { withMainControls } from '@eventbrite/eds-structure';

import { Button } from '@eventbrite/eds-button';

import PageHeader from '../../components/PageHeader';
import PasswordlessLoginMessage from '../../components/PasswordlessLoginMessage';

import ResetPasswordForm from '../../components/newForms/ResetPasswordForm';

import SplitContainer from '../../connectedComponents/SplitContainer';

import ToSModal from '../../connectedComponents/ToSModal';

import { TOS_SOCIAL_MUST_BE_ACCEPTED } from '../../constants/messages';

import {
    TOSMODAL_PASSWORDLESS_SHOWED,
    TOSMODAL_PASSWORDLESS_DENIED,
    TOSMODAL_PASSWORDLESS_ACCEPTED,
    TOSMODAL_SET_PASSWORD_SHOWED,
    TOSMODAL_SET_PASSWORD_DENIED,
    TOSMODAL_SET_PASSWORD_ACCEPTED,
    GA_PASSWORDLESS,
} from '../../constants/analytics';

import './Passwordless.scss';

class PasswordlessPage extends React.Component {
    static propTypes = {
        clearAuthNotification: PropTypes.func,
        handleSignupClick: PropTypes.func,
        handlePasswordlessLogin: PropTypes.func,
        handlePasswordlessSetPassword: PropTypes.func,
        handlePasswordlessEmailClicked: PropTypes.func,
        handlePasswordlessSavePasswordClicked: PropTypes.func,
    };

    state = {
        showSetPasswordField: false,
        isSetPasswordFlow: false,
        password: null,
    };
    componentDidMount() {
        const {
            router: {
                location: { query },
            },
            handlePasswordlessEmailClicked,
        } = this.props;
        handlePasswordlessEmailClicked({
            isHardAccount: query['is_hard_account'],
        });
        if (query['is_hard_account'] == 'True') {
            this._handleTopButtonOnClick();
        }
    }

    _handleTopButtonOnClick = () => {
        const {
            router: {
                location: { query },
            },
            handlePasswordlessLogin,
            handlePasswordlessContinueClicked,
        } = this.props;
        this.setState({ isSetPasswordFlow: false });
        const mustAcceptToS = query['must_accept_tos'];
        const isHardAccount = query['is_hard_account'];
        if (mustAcceptToS != 'True' && isHardAccount != 'True') {
            handlePasswordlessContinueClicked();
        }

        handlePasswordlessLogin({
            token: query['h'],
            isHardAccount,
            must_accept_tos: mustAcceptToS,
            referrer: query['referrer'],
        });
    };

    _handleBotButtonOnClick = () => {
        const { handlepasswordlessSetPasswordClicked } = this.props;

        handlepasswordlessSetPasswordClicked();
        this.setState({ showSetPasswordField: true });
    };

    _handleSavePasswordClick = (formData) => {
        const {
            handlePasswordlessSavePasswordClicked,
            router: {
                location: { query },
            },
        } = this.props;
        handlePasswordlessSavePasswordClicked();
        this.setState({
            isSetPasswordFlow: true,
            password: formData['password'],
        });
        if (query['must_accept_tos'] == 'True') {
            this._handleToSDisplay({ origin: 'SetPassword' });
        } else {
            this._handleSavePassword();
        }
    };

    _handleSavePassword = () => {
        const {
            router: {
                location: { query },
            },
            handlePasswordlessSetPassword,
        } = this.props;
        handlePasswordlessSetPassword({
            password: this.state.password,
            token: query['h'],
            must_accept_tos: query['must_accept_tos'],
            referrer: query['referrer'],
        });
    };

    _handleToSAccepted = () => {
        const { acceptToS } = this.props;

        acceptToS({
            onAccept: this.state.isSetPasswordFlow
                ? this._handleSavePassword
                : this._handleTopButtonOnClick,
            actionName: this.state.isSetPasswordFlow
                ? TOSMODAL_SET_PASSWORD_ACCEPTED
                : TOSMODAL_PASSWORDLESS_ACCEPTED,
            trackLabel: GA_PASSWORDLESS,
        });
    };

    _handleToSDisplay = ({ origin = 'Login' }) => {
        const { showToS, handlePasswordlessContinueClicked } = this.props;
        if (origin == 'Login') {
            this.setState({ isSetPasswordFlow: false });
            handlePasswordlessContinueClicked();
        }

        showToS({
            actionName:
                origin == 'Login'
                    ? TOSMODAL_PASSWORDLESS_SHOWED
                    : TOSMODAL_SET_PASSWORD_SHOWED,
            trackLabel: GA_PASSWORDLESS,
        });
    };

    _handleToSDenied = () => {
        const { cancelToS } = this.props;

        cancelToS({
            actionName: this.state.isSetPasswordFlow
                ? TOSMODAL_SET_PASSWORD_DENIED
                : TOSMODAL_PASSWORDLESS_DENIED,
            notificationMessage: TOS_SOCIAL_MUST_BE_ACCEPTED,
            trackLabel: GA_PASSWORDLESS,
        });
    };

    render() {
        const {
            router: {
                location: { query },
            },
            passwordlessLoginStatus,
            isLoading,
            setPasswordlessEmailStatus,
            handleSendPasswordlessLink,
            passwordlessEmailStatus,
            signUpSecondStep,
        } = this.props;
        const usesNewStyles = true;
        const pageHeaderProps = {
            headerText: gettext('Welcome back!'),
            usesNewStyles,
            subtitleText: gettext(
                'You can set a password or log in without one. ',
            ),
        };
        const topButtonCTA = gettext('Continue without a password');
        const botButtonCTA = gettext('Set a password');

        const mustAcceptTOS = query['must_accept_tos'];
        let modalToS = (
            <ToSModal
                dataTestId="passwordless-tos"
                onAcceptToS={this._handleToSAccepted}
                onCancelToS={this._handleToSDenied}
            />
        );
        let onPasswordLessLoginSubmit = this._handleToSDisplay;
        if (mustAcceptTOS != 'True') {
            modalToS = null;
            onPasswordLessLoginSubmit = this._handleTopButtonOnClick;
        }

        const setPasswordForm = (
            <>
                <ResetPasswordForm
                    buttonCTA={gettext('Save password')}
                    onSubmit={this._handleSavePasswordClick}
                    buttonStyle="link"
                />
            </>
        );

        const setPasswordButton = (
            <Button
                __containerClassName=""
                onClick={this._handleBotButtonOnClick}
            >
                {botButtonCTA}
            </Button>
        );
        if (query['is_hard_account'] != 'True') {
            return (
                <SplitContainer
                    shouldShowSecondaryPanel={usesNewStyles}
                    usesNewStyles={usesNewStyles}
                    header={<PageHeader {...pageHeaderProps} />}
                >
                    <>
                        <Button
                            style="fill"
                            onClick={onPasswordLessLoginSubmit}
                        >
                            {topButtonCTA}
                        </Button>

                        <div className="split-container__divider eds-l-pad-bot-5 eds-l-pad-top-5">
                            <div className="split-container__divider-text eds-text-bm eds-text-weight--heavy">
                                {gettext('or')}
                            </div>
                        </div>
                        {this.state.showSetPasswordField
                            ? setPasswordForm
                            : setPasswordButton}

                        {modalToS}
                    </>
                </SplitContainer>
            );
        } else {
            return (
                <SplitContainer
                    shouldShowSecondaryPanel={false}
                    usesNewStyles={true}
                    shouldUseFullWidth={true}
                    header={null}
                >
                    <PasswordlessLoginMessage
                        status={passwordlessLoginStatus}
                        isLoading={isLoading}
                        handleSendPasswordlessLink={handleSendPasswordlessLink}
                        setPasswordlessEmailStatus={setPasswordlessEmailStatus}
                        passwordlessEmailStatus={passwordlessEmailStatus}
                        signUpSecondStep={signUpSecondStep}
                        referrer={query['referrer']}
                    />
                </SplitContainer>
            );
        }
    }
}
// https://www.evbqa.com/signin/resetpassword?utm_campaign=reset_password&must_accept_tos=False&h=VILPYYOBWVEYHDHQ3BGLRSPBNT5KX3IX308745989&firstpassword=1&mobile_client=None&utm_source=eb_email&utm_medium=email&external_provider=None&must_link_account=False

export default withMainControls(PasswordlessPage);
